<script setup lang="ts">
interface Props {
  firstRow?: boolean;
  lastRow?: boolean;
  noSidePadding?: boolean;
  backgroundColor?: 'bg-dark' | 'bg-light' | 'bg-white';
}

withDefaults(defineProps<Props>(), {
  firstRow: false,
  lastRow: false,
  noSidePadding: false,
  backgroundColor: 'bg-white',
});
</script>

<template>
  <div
    :class="[
      'content-row',
      backgroundColor,
      firstRow && 'content-row--first',
      lastRow && 'content-row--last',
      noSidePadding && 'content-row--no-side-padding',
    ]"
  >
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
.bg-dark {
  background-color: @color-background-dark;
}

.bg-light {
  background-color: @color-background-light;
}

.bg-white {
  background-color: white;
}

.content-row {
  padding: 1.57rem;
  color: @color-primary;
  display: flex;
  align-items: center;
  border-bottom: 1px solid @color-mid-tone;

  &.content-row--first {
    border-top: 1px solid @color-mid-tone;
  }

  &.content-row--last {
    margin-bottom: 1.6rem;
  }

  &.content-row--no-side-padding {
    padding-left: 0;
    padding-right: 0;
  }

  p {
    margin-bottom: 0.57rem;

    &:last-of-type {
      margin-bottom: 0px;
    }
  }
}
</style>
